<template>
  <div class="timebar" id="timebar" v-if="challenge" :loaded="loaded">
    <div class="toolbar-desc challenge-mode" id="timeline-challenge" v-if="challenge.number>0">
      <span :level="[challenge.level]">{{challenge.level}}</span><br>
      Challenge <i>{{challenge.number}}</i>
    </div>
    <div class="toolbar-desc tutorial-mode" id="timeline-challenge" v-if="challenge.number==0">
      Game Tutorial
    </div>
    <div class="toolbar-control">
      <div class="toolbar-button inactive" v-if="!canPause(challenge)">
        <span class="icon-play"></span>
        <span class="icon-status">Playing</span>
      </div>
      <div class="toolbar-button" v-if="simulation.running && canPause(challenge)" @click="stop()">
        <span class="icon-play"></span>
        <span class="icon-status">Playing</span>
      </div>
      <div class="toolbar-button" v-if="!simulation.running && canPause(challenge)" @click="start()">
        <span class="icon-play icon-paused"></span>
        <span class="icon-status">Paused</span>
      </div>
      <div class="toolbar-progress" id="timeline-progress">
        <div class="progress-background">
          <div class="progress-value" :style="{width:progressWidth}"><div class="progress-label" >{{timeOfTheDay}}</div></div>
        </div>
        <div v-for="(event,eidx) in events" :key="eidx" :incoming="event.incoming" class="time-event" :style="{left:eventPosition(event)}" v-show="event.visible!==false">
          <div class="event-bubble" :event="event.type" ></div>
          <div class="event-indicator"></div>
          <div class="event-point"></div>
          <div class="event-indicator"></div>
        </div>
      </div>
      <div class="toolbar-time">End<br><span>24h 00m</span></div>
    </div>
    <div class="toolbar-exit"><button @click="exit()" class="action-button">Exit</button></div>
  </div>
</template>

<script>
import simulation from '@/lib/simulation.js'

export default {
  name: 'comp',
  data: function () {
    return {
      pumpComp: null,
      simulation: simulation,
      loaded: false
    }
  },
  props: {
    pump: Object,
    challenge: Object
  },
  mounted: function () {
    this.pumpComp = this.pump
    const self = this
    setTimeout(function () {
      self.loaded = true
    }, 100)
  },
  methods: {
    canPause: function (challenge) {
      return challenge.number > 0 || !simulation.data.tutorialId
    },
    stop: function () {
      if (this.pumpComp) {
        this.pumpComp.stopMonitor()
      }
    },
    start: function () {
      if (this.pumpComp) {
        this.pumpComp.startMonitor()
        const params = this.$router.history.current.params
        if (params.view === 'messages') {
          this.$router.push('/challenge/' + params.number + '/pumpcontrol')
        }
      }
    },
    exit: function () {
      this.$emit('exit')
    },
    eventPosition: function (event) {
      return (event.position * 100 / simulation.params.END_TIME).toFixed(1) + '%'
    }
  },
  computed: {
    progressWidth: function () {
      if (this.pumpComp) {
        return (Math.max(600, this.pumpComp.currentTime) * 100 / simulation.params.END_TIME).toFixed(1) + '%'
      }
      return ''
    },
    events: function () {
      return simulation.data.events
    },
    timeOfTheDay: function () {
      let hours = Math.floor(simulation.data.currentTime / 3600)
      if (hours < 10) hours = '0' + hours
      let minutes = (simulation.data.currentTime / 60) % 60
      if (minutes < 10) minutes = '0' + minutes
      return hours + 'h ' + minutes + 'm'
    }
  },
  watch: {
    pump: function (newValue) {
      this.pumpComp = this.pump
    },
    challenge: function (newValue) {
      this.$forceUpdate()
    }
  }
}
</script>

<style scoped lang="scss">
.timebar {
  position: relative;
  width: 95%;
  max-width: 1600px;
  margin: 0 auto 0 auto;
  background-color: #fff;
  height: 70px;
  border-radius: 35px 35px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 14px 0 28px;
  opacity: 0;
  transition: opacity linear .5s;
  &[loaded='true']{
    opacity: 1;
    transition: opacity linear .5s;
  }
}
.toolbar-desc{
  text-align: left;
  min-height: 40px;
  line-height: 0.9em;
  &.tutorial-mode{
    display: flex;
    align-items: center;
    font-size: 20px;
  }
  &.challenge-mode{
    font-size: 24px;
    padding-bottom: 4px;
  }
  br{
    height: 0px;
  }
  span{
    font-size: 14px;
    text-transform: uppercase;
    font-weight: bold;
    &[level='Easy']{
      color:#00D81D;
    }
    &[level='Intermediate']{
      color:#FFCC01;
    }
  }
  i{
    font-weight: bold;
  }
  margin-right: 10px;
}
.toolbar-control{
  flex: 1;
  max-height: 50px;
  height: 95%;
  border-radius: 32px 32px;
  width: 18 0px;
  display: flex;
  align-items: center;
  background-color: #F5F5F5;
  > span{
    display: inline-block;
  }
  .icon-play{
    width: 42px;
    height: 42px;
    border-radius:99% 99%;
    border: 2px solid #BCE0FD;
    margin-right: 8px;
    margin-left: 2px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: url(../assets/img/pause-icon.svg) no-repeat center;
    background-size: 14px 18px;
    transition: background-color 0.2s, border-color 0.2s, background-image 0.2s;
    &.icon-paused{
      background: url(../assets/img/play-icon.svg) no-repeat center;
      background-size: 20px 20px;
      background-color: #00B5E2;
      border: 2px solid #00B5E2;
    }
  }
  .icon-status{
    text-transform: uppercase;
    font-weight: bold;
    font-size: 18px;
    color: #8F9297;
    padding: 0 16px 0 4px;
    box-sizing: border-box;
  }
}
.toolbar-button{
  border-radius: 25px;
  height: 100%;
  border: 2px solid #D9D9D9;
  background-color: #fff;
  display: flex;
  align-items: center;
  min-width: 155px;
  cursor: pointer;
  &.inactive{
    cursor: auto;
    opacity: 0.5;
  }
  &:not(.inactive):hover .icon-play:not(.icon-paused){
    background: url(../assets/img/pause-icon-hover.svg) no-repeat center;
    background-size: 14px 18px;
  }
  &:not(.inactive):hover .icon-paused{
    background-color: #005EB8;
    border-color: #005EB8;
  }
}
.toolbar-progress{
  flex: 1;
  display: flex;
  align-items: center;
  margin: 0 20px;
  padding: 10px 0;
  position: relative;
  .progress-background{
    width: 100%;
    height: 12px;
    background-color: #B2F3BA;
    border-radius: 6px;
    .progress-value{
      border-radius: 6px 0 0 6px;
      background-color: #00D81D;
      height: 100%;
      width: 0;
      transition: width linear .3s;
      position: relative;
      &::before{
        content: ' ';
        position: absolute;
        width: 4px;
        height: 30px;
        background-color: #00D81D;
        right: 0;
        top: 1px;
      }
      .progress-label{
        background-image: url('../assets/img/Icon_Time.svg');
        background-repeat: no-repeat;
        background-position: 0 4px;
        position: absolute;
        padding: 8px 0 8px 24px;
        border-radius: 5px;
        background-color: #fff;
        font-weight: bold;
        width: 106px;
        top: 32px;
        height: 32px;
        right: -50px;
        box-shadow: 0px 0px 10px 3px rgba(128,128,128,0.5);
      }
    }
  }
  .time-event{
    position: absolute;
    width: 30px;
    height: 50px;
    bottom: -10px;
    margin-left: -15px;
    display: flex;
    flex-direction: column;
    align-items: center;
    .event-bubble{
      z-index:1;
      width: 64px;
      height: 64px;
      background-repeat: no-repeat;
      background-position: center;
      background-size: 66px 74px;
      position: absolute;
      top: -50px;
      &[event='sunrise']{
        background-image: url('../assets/img/event-sunrise.svg');
      }
      &[event='cloudy']{
        background-image: url('../assets/img/event-cloudy.svg');
      }
      &[event='hot']{
        background-image: url('../assets/img/event-hot.svg');
      }
      &[event='sunny']{
        background-image: url('../assets/img/event-sunny.svg');
      }
      &[event='rain']{
        background-image: url('../assets/img/event-rain.svg');
      }
      &[event='storm']{
        background-image: url('../assets/img/event-thunder.svg');
      }
      &[event='night']{
        background-image: url('../assets/img/event-night.svg');
      }
    }
    &[incoming='true']{
      .event-bubble{
        animation: bounce;
        -webkit-animation-duration: .5s;
        animation-duration: .5s;
        -webkit-animation-fill-mode: both;
        animation-fill-mode: both;
        -webkit-animation-timing-function: linear;
        animation-timing-function: linear;
        animation-iteration-count: infinite;
        -webkit-animation-iteration-count: infinite;
      }
    }

    .event-indicator{
      width: 2px;
      height: 16px;
      flex:0 0 16px;
      background-color: rgba(128,128,128,0.3);
      position: relative;
    }
    .event-point{
      margin: 4px 0 4px 0;
      width: 8px;
      height: 8px;
      background-color: #fff;
      border-radius: 6px 6px;
      border: 1px solid #e0e0e0;
    }
  }
}
.toolbar-time{
  text-align: left;
  text-transform: uppercase;
  color: #8F9297;
  font-weight: bold;
  font-size: 14px;
  margin-right: 20px;
  span{
    color: #1E2F46;
    text-transform: none;
    font-size: 18px;
  }
}
.toolbar-exit{
  margin-left: 16px;
  button{
    margin-right: 0;
  }
}
@media (max-height: 800px) {
  .timebar{
    height: 50px;
    border-radius: 25px 25px;
    padding: 0 10px 0 20px;
  }
  .toolbar-desc.challenge-mode{
    font-size: 18px;
  }
  .toolbar-desc.tutorial-mode{
    font-size: 16px;
  }
  .toolbar-control .icon-play{
    width: 34px;
    height: 34px;
  }
  .toolbar-control .icon-status{
    font-size: 16px;
  }
  .toolbar-button{
    min-width: 140px;
  }
  .toolbar-progress{
    height: 40px;
  }
  .toolbar-control{
    height: 40px;
  }
  .toolbar-progress .time-event{
    height: 40px;
    top: 0;
    .event-bubble{
      width: 52px;
      height: 52px;
      top: -36px;
      background-size:contain;
    }
    .event-indicator{
      height:12px;
      flex: 0 0 12px;
    }
  }
  .timebar-container{
    top: 1vw;
  }
}
</style>
<style lang="scss">
@-webkit-keyframes bounce {
  0%, 100% {
    -webkit-transform: translateY(0);
  }
  50% {
    -webkit-transform: translateY(-5px);
  }
}
@keyframes bounce {
  0%, 100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-5px);
  }
}
@keyframes shake {
  0%, 100% {
    transform: translateX(0);
  }
  50% {
    transform: translateX(5px);
  }
}
</style>
